if (!customElements.get('wf-product-summary')) {
  customElements.define('wf-product-summary', class extends HTMLElement {
    connectedCallback() {
      this.onReady = () => this.connect();
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', this.onReady, { once: true });
      else this.connect();
    }
    connect() {
      const info = this.closest('product-info');
      this.form = document.getElementById(info?.getAttribute('form'));
      this.onVariant = event => {
        const name = this.dataset.productTitle.toLowerCase();
        const choice = event.detail.variant.title.toLowerCase().replace(/[\s.\-]/g, '');
        let contents = '';
        if (name.includes('set') && !choice.includes('elite')) {
          if (choice.includes('2piece')) {
            if (choice.includes('medium')) contents = 'Carry-on + Medium check-in';
            else if (choice.includes('large')) contents = 'Carry-on + Large check-in';
          } else if (choice.includes('checkinset')) contents = 'Medium check-in + Large check-in';
          else if (/3[ -]piece/.test(name)) contents = 'Carry-on + Medium check-in + Large check-in';
        }
        const target = this.querySelector('.wf-pdp-summary__set');
        target.hidden = !contents;
        target.querySelector('.wf-pdp-summary__contents').textContent = contents;
      };
      this.form?.addEventListener('variant:change', this.onVariant);
    }
    disconnectedCallback() {
      document.removeEventListener('DOMContentLoaded', this.onReady);
      this.form?.removeEventListener('variant:change', this.onVariant);
    }
  });
}

if (!customElements.get('wf-smart-upsell')) {
  customElements.define('wf-smart-upsell', class extends HTMLElement {
    connectedCallback() {
      this.onReady = () => {
        const recommendations = this.querySelector('product-recommendations');
        this.onEmpty = () => { this.hidden = true; };
        recommendations?.addEventListener('is-empty', this.onEmpty);
        this.unsubscribe = window.theme?.pubsub?.subscribe(window.theme.pubsub.PUB_SUB_EVENTS.cartUpdate, ({ cart }) => {
          const card = this.querySelector('[data-wf-upsell-product-id]');
          if (card && cart?.items?.some(item => String(item.product_id) === card.dataset.wfUpsellProductId)) this.hidden = true;
        });
      };
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', this.onReady, { once: true });
      else this.onReady();
    }
    disconnectedCallback() {
      document.removeEventListener('DOMContentLoaded', this.onReady);
      this.querySelector('product-recommendations')?.removeEventListener('is-empty', this.onEmpty);
      this.unsubscribe?.();
    }
  });
}
